<template>
    <vue-editor v-model="model" :editorToolbar="customToolbar" />
</template>

<script setup>

import { defineProps, computed, defineEmits } from 'vue'

const emit = defineEmits(['input'])

const props = defineProps({
    value: String,
    label: { type: String, required: false },
    errorMessages: { type: [Object, Array], required: false },
    autoGrow: { type: Boolean, default: false },
    optionsHeaders: { type: Array, default: () => [false, 1, 2, 3, 4, 5, 6] },
    optionsFontStyle: { type: Array, default: () => ["bold", "italic", "underline", "strike"] },
    optionsFonts: { type: Array, default: () => [] },
    optionsFontSize: { type: Array, default: () => ["small", false, "large", "huge"] },
    optionsAlign: { type: Array, default: () =>  [ { align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }] },
    optionsLink: { type: Array, default: () => ["link"] },
})

const model = computed({
    get() {
        return props.value
    },
    set(val) {
        emit('input', val)
    }
})

const customToolbar = computed(() => {

    let options = [];

    if(props.optionsHeaders && props.optionsHeaders.length > 0) {
        options = [
            ...[{ header:  props.optionsHeaders }]
        ]
    }

    if(props.optionsFontStyle && props.optionsFontStyle.length > 0) {
        options = [
            ...options,
            ...props.optionsFontStyle
        ]
    }

    if(props.optionsFonts && props.optionsFonts.length > 0) {
        options = [
            ...options,
            ...[{ font: props.optionsFonts }]
        ]
    }

    if(props.optionsFontSize && props.optionsFontSize.length > 0) {
        options = [
            ...options,
            ...[{ size: props.optionsFontSize }]
        ]
    }

    if(props.optionsAlign && props.optionsAlign.length > 0) {
        options = [
            ...options,
            ...props.optionsAlign
        ]
    }

    if(props.optionsLink && props.optionsLink.length > 0) {
        options = [
            ...options,
            ...props.optionsLink
        ]
    }

    return options
})

</script>